import Tabs from 'antd/es/tabs';

export default Tabs;
